import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderSlot as _renderSlot, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "dropdown" }
const _hoisted_2 = ["disabled"]

import { computed, ref, nextTick } from "vue";
import { VIconSvg } from "@/components";
import PerfectScrollbar from "perfect-scrollbar";
import store from "@/store";

interface Props {
  /**
   * Set button text.
   */
  text?: string;
  /**
   * The variant of the button.
   * @values regular, select, icon, button-icon
   */
  variant?: string;
  /**
   * The size of the button.
   * @values md
   */
  size?: string;
  /**
   * Make the dropdown icon visible.
   */
  dropdownIcon?: boolean;
  /**
   * The position of dropdown list on the y-axis.
   * @values top, bottom
   */
  listYPosition?: string;
  /**
   * The position of dropdown list on the x-axis.
   * @values left, right
   */
  listXPosition?: string;
  /**
   * Make button inactive.
   */
  disabled?: boolean;
  /**
   * Set icon name if "icon" variant is used.
   */
  iconName?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VButtonDropdown',
  props: {
    text: { default: "" },
    variant: { default: "regular" },
    size: { default: "md" },
    dropdownIcon: { type: Boolean, default: true },
    listYPosition: { default: "bottom" },
    listXPosition: { default: "left" },
    disabled: { type: Boolean, default: false },
    iconName: { default: "" }
  },
  emits: ["hide"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const emit = __emit;

const props = __props;

const active = ref(false);
const scroll = ref({});

const toggle = () => {
  active.value = !active.value;

  if (!isMobileDevice.value) {
    nextTick(() => {
      scroll.value = new PerfectScrollbar(".dropdown-content");
    });
  }
};

const scrollUpdate = () => {
  if (!isMobileDevice.value) {
    scroll.value?.update();
  }
};

const show = () => {
  active.value = true;
};

const hide = () => {
  active.value = false;

  emit("hide");
};

const isMobileDevice = computed(() => store.getters["viewport/isMobileDevice"]);

const buttonClass = computed(() => {
  return `${props.variant} ${props.variant}-size-${props.size}`;
});

const iconSize = computed(() => {
  let value = "md";

  switch (props.variant) {
    case "regular":
      value = "sm";
      break;
    case "select":
      value = "xs";
      break;
  }

  return value;
});

const iconClass = computed(() => {
  return active.value && ["regular", "button-fc-accent"].includes(props.variant)
    ? "icon-rotate"
    : "";
});

const iconNameValue = computed(() => {
  const iconName = {
    icon: props.iconName || "ArrowDown",
    "button-icon": props.iconName || "ArrowDown",
    "button-fc-accent": props.iconName || "ArrowDown",
    regular: props.iconName || "ArrowDown",
    select: props.iconName || "UnfoldMore",
  };

  return iconName[props.variant];
});

const dropdownContentClasses = computed(() => {
  return {
    "dropdown-content-top": props.listYPosition === "top",
    "dropdown-content-left": props.listXPosition === "left",
    "dropdown-content-right": props.listXPosition === "right",
  };
});

const iconColor = computed(() => {
  return props.disabled ? "fc-stroke" : props.variant === "regular" ? "fc-subduet" : "fc-stroke";
});

__expose({
  isShownItems: active,
  hide,
  show,
});

return (_ctx: any,_cache: any) => {
  const _directive_touch = _resolveDirective("touch")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("button", {
      "data-cy": "dropdown",
      class: _normalizeClass(["dropdown-button", buttonClass.value]),
      disabled: props.disabled
    }, [
      _createTextVNode(_toDisplayString(props.text) + " ", 1),
      (props.dropdownIcon)
        ? (_openBlock(), _createBlock(_unref(VIconSvg), {
            key: 0,
            name: iconNameValue.value,
            color: iconColor.value,
            size: iconSize.value,
            class: _normalizeClass(["icon", iconClass.value])
          }, null, 8, ["name", "color", "size", "class"]))
        : _createCommentVNode("", true)
    ], 10, _hoisted_2)), [
      [_directive_touch, toggle]
    ]),
    _createVNode(_Transition, { name: "dropdown-content" }, {
      default: _withCtx(() => [
        (active.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["dropdown-content", dropdownContentClasses.value]),
              onMouseover: scrollUpdate
            }, [
              _renderSlot(_ctx.$slots, "default")
            ], 34))
          : _createCommentVNode("", true)
      ], undefined, true),
      _: 3
    })
  ])), [
    [_directive_click_outside, hide]
  ])
}
}

})